/** Nhận diện Quảng Ngãi theo yêu cầu đã duyệt trong CR-QNG-001. */
export const SYSTEM_NAME = "Hệ thống cơ sở dữ liệu 3D nghĩa trang liệt sĩ tỉnh Quảng Ngãi";
export const SYSTEM_PORTAL_TITLE = "HỆ THỐNG PHẦN MỀM CSDL 3D NGHĨA TRANG LIỆT SĨ";
export const SYSTEM_SHORT_NAME = "CSDL 3D nghĩa trang liệt sĩ";
export const SYSTEM_LOCALITY = "Tỉnh Quảng Ngãi";
export const SYSTEM_LOGO_PATH = "/quoc-huy.png";
